import Vue from "vue";
import VueRouter from "vue-router";
import login from "../views/login/Login.vue";
import mfaCodeValidation from "../views/login/MFACodeValidation.vue";
import register from "../views/account/register.vue";
import forgotPassword from "../views/account/forgotPassword.vue";
import resetPassword from "../views/account/resetPassword.vue";
import userManagement from "../views/userManagement/userManagement.vue";
import dashboard from "../views/dashboard/dashboard.vue";
import faq from "../views/FAQ/FAQ.vue";
import reports from "../views/reports/Reports.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "home",
        component: dashboard,
        props: true,
        meta: {
            breadcrumb: "dashboard"
        }
    },
    {
        path: "/login",
        name: "login",
        component: login,
        props: true,
        meta: {
            breadcrumb: "login-view.login"
        }
    },
    {
        path: "/mfaCodeValidation",
        name: "mfaCodeValidation",
        component: mfaCodeValidation,
        props: true,
        meta: {
            breadcrumb: "login-view.mfaTitle"
        }
    },
    {
        path: "/register",
        name: "register",
        component: register,
        props: true,
        meta: {
            breadcrumb: "login-view.register"
        }
    },
    {
        path: "/forgotPassword",
        name: "forgotPassword",
        component: forgotPassword,
        props: true,
        meta: {
            breadcrumb: "login-view.forgotPassword"
        }
    },
    {
        path: "/resetPassword",
        name: "resetPassword",
        component: resetPassword,
        props: true,
        meta: {
            breadcrumb: "reset-password.title"
        }
    },
    {
        path: "/userManagement",
        name: "userManagement",
        component: userManagement,
        props: true,
        meta: {
            breadcrumb: "user-management.title"
        }
    },
    {
        path: "/reports",
        name: "reports",
        component: reports,
        props: true,
        meta: {
            breadcrumb: "reports.menu"
        }
    },
    {
        path: "/faq",
        name: "faq",
        component: faq,
        props: true,
        meta: {
            breadcrumb: "app.faq"
        }
    },
    {
        path: "*",
        redirect: "/",
    },
];

const router = new VueRouter({
    mode: "hash",
    base: process.env.BASE_URL,
    scrollBehavior: function (to) {
        if (to.hash) {
            return { selector: to.hash };
        } else {
            return { x: 0, y: 0 };
        }
    },
    routes,
});

export default router;
